function AddIfNotExists(
    list: string[] | null | undefined,
    value: string | null | undefined,
    ignoreCase: boolean = false
): void {
    if (!list || !Array.isArray(list)) return;
    if (!value || value.trim() === "") return;

    const exists = ignoreCase
        ? list.some(item => item.toLowerCase() === value.toLowerCase())
        : list.includes(value);

    if (!exists) {
        list.push(value);
    }
}
function RemoveIfExists(
    list: string[] | null | undefined,
    value: string | null | undefined,
    ignoreCase: boolean = false
): void {
    if (!list || !Array.isArray(list)) return;
    if (!value || value.trim() === "") return;

    const index = ignoreCase
        ? list.findIndex(item => item.toLowerCase() === value.toLowerCase())
        : list.indexOf(value);

    if (index !== -1) {
        list.splice(index, 1);
    }
}